import {itemNoUndefValueComparator} from './object';

function getComparedArray(array, itemComparator) {
    return array.filter((value, index) => (
        itemComparator({value, index, array})
    ));
}

function getNoUndefValuesArray(array) {
    return getComparedArray(array, itemNoUndefValueComparator);
}

function getUniqueValuesArray(array) {
    return Array.from(new Set(array));
}

export {
    getNoUndefValuesArray,
    getUniqueValuesArray
};
